import apiService from "../../api/api.service";
import {
  SlugControlRequest,
  SlugControlResponse,
} from "./slugControl.types";

export const fetchSlugControl = async (
  data: SlugControlRequest,
): Promise<SlugControlResponse> => {
  return apiService.post<SlugControlResponse, SlugControlRequest>(
    "/general/slug-control",
    data,
  );
};
